import { SetToothFullHeadMPRSliceSelectionReq } from '@/shared/api/protocol-ts/api/core/svc_report_pb';
import { ToothFullHeadMPRSliceGeometrySource } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';
import type { FullHeadMPRViewSnapshot } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { makeFullHeadMprViewMessage } from './fullHeadMprViewGeometry';

export const makeFullHeadMprViewSelectionRequest = ({
  snapshot,
  toothID,
}: {
  snapshot: FullHeadMPRViewSnapshot;
  toothID: string;
}) => {
  const { heightPx, view, widthPx } = snapshot;
  return new SetToothFullHeadMPRSliceSelectionReq({
    ToothID: toothID,
    IsAdded: true,
    Geometry: {
      GeometrySource:
        ToothFullHeadMPRSliceGeometrySource.ToothFullHeadMPRSliceGeometrySourceView,
      HeightPx: heightPx,
      Scale: view.widthMm / widthPx,
      ThicknessMm: view.thicknessMm,
      VolumeFileID: view.volumeFileID,
      WidthPx: widthPx,
    },
    Target: {
      case: 'View',
      value: makeFullHeadMprViewMessage(view),
    },
  });
};
